import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  statActions: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.2rem",
    "& span": {
      whiteSpace: "nowrap",
      fontSize: "0.75rem",
      fontWeight: "bold",
      cursor: "pointer",
      backgroundColor: theme.palette.primary.main,
      borderColor: "transparent",
      borderWidth: "1px",
      borderStyle: "solid",
      color: "white",
      padding: "2px 6px",
      borderRadius: "6px",
    },
    "& span.active": {
      backgroundColor: "white",
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
  },
}));

export default function RangeSelection(props) {
  const { activeRange, onRangeChange } = props;
  const classes = useStyles();
  const ranges = [
    { label: "All Time", key: "all-time" },
    { label: "90 days", key: "90-days" },
    { label: "60 days", key: "60-days" },
    { label: "30 days", key: "30-days" },
    { label: "14 days", key: "14-days" },
    { label: "7 days", key: "7-days" },
    { label: "Yesterday", key: "yesterday" },
    { label: "Today", key: "today" },
  ].reverse();

  return (
    <div className={classes.statActions}>
      {ranges.map((range, index) => (
        <span key={index} className={activeRange?.key == range?.key ? "active" : ""} onClick={() => onRangeChange(range)}>
          {range?.label}
        </span>
      ))}
    </div>
  );
}
